// @charset "utf-8"
import axios from 'axios'

const state = {
    pool: []
}

const getters = {
    logoSeries: (state) => (fundId) => {
        let result = state.pool.find(serie => Number(serie.fundId) === Number(fundId))
        if (!result) {
            return false
        }
        return result.series
    }
}

const mutations = {
    updatePool (state, data) {
        let poolIdx = state.pool.findIndex(serie => Number(serie.fundId) === Number(data.fundId))
        if (poolIdx === -1) {
            state.pool.push(data)
        } else {
            state.pool[poolIdx] = data
        }
    }
}

const actions = {
    requestSeries (context, fundId) {
        return axios.get('/robot/robot/queryprofitrate/?fund_id=' + fundId).then((response) => {
            // 判断http状态
            return response.data
        }).then((data) => {
            // 判断errorcode
            return data.result
        }).then((result) => {
            let series = []
            Object.keys(result).forEach((date) => {
                series.push([Number(date), Number(result[date][0])])
            })
            context.commit('updatePool', {fundId, series})
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/logo.js